import { useState } from "react";
import { useTranslation } from "react-i18next";

import HelpOutline from "@material-ui/icons/HelpOutline";
import IconButton from "@material-ui/core/IconButton";
import "../components/Modal.css";
import "./Header.css";

import PopPop from "react-poppop";

const Header = () => {
  const [t, i18n] = useTranslation("global");
  const [show, setShow] = useState(false);
  const toggleShow = (show) => {
    setShow(show);
  };

  return (
    <div className="header__top">
      <div className="header__title">
        <div>
          <h3>
            <span>{t("HEADER.title.shortcut")}</span> - {t("HEADER.title.full")}
          </h3>
        </div>
      </div>
      <PopPop
        position="centerCenter"
        open={show}
        closeBtn={true}
        closeOnEsc={true}
        onClose={() => toggleShow(false)}
        closeOnOverlay={true}
        contentStyle={{
          backgroundColor: "white",
          overflow: "hidden",
        }}
      >
        <div className="modal__smallContainer">
          <h3>
            <span>{t("HEADER.modal.first.title")}</span>
          </h3>
          <p>{t("HEADER.modal.first.paragraph")}</p>
          <div className="imagen">
            <img src="https://escolaportbarcelona.com/wp-content/uploads/2021/02/Escola-Port-Club-de-navegacion-j80-barcelona-00.jpg" />
          </div>
          <h3>
            <span>{t("HEADER.modal.second.title")}</span>
          </h3>
          <p>{t("HEADER.modal.second.paragraph")}</p>
          <div className="imagen">
            <img src="https://escolaportbarcelona.com/wp-content/uploads/2021/02/Escola-Port-Club-de-navegacionCruise-barcelona-04jpg.jpg" />
          </div>
          <br />
          <hr />
          <br />
          <div className="modal__paragraph">
            <p>{t("HEADER.modal.third.paragraph1")}</p>
          </div>
          <div className="modal__paragraph">
            <p>{t("HEADER.modal.third.paragraph2")}</p>
          </div>
        </div>
      </PopPop>
      <div className="header__iconContainer">
        <IconButton
          onClick={() => {
            toggleShow(true);
          }}
        >
          <HelpOutline />
        </IconButton>
      </div>
    </div>
  );
};

export default Header;
